/* eslint-disable import/no-unused-modules, no-unused-vars */
import React from 'react';
import { Modal } from 'react-bootstrap';
import Add_ValuationConfig from 'components/widgets/forms/setup/Add_ValuationConfig';

function AddValuationConfig(props) {
  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="text-grey">Add Valuation Configuration</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Add_ValuationConfig {...props} />
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default AddValuationConfig;

